<script>
  import { DataTable, Link, TooltipDefinition } from 'carbon-components-svelte';
  import { useNavigate } from 'svelte-navigator';

  import { updateKeys } from '../../stores';

  export let title, headers, routeGenerator, data;

  const navigate = useNavigate();

  $: dataWithId = data?.map((item, id) => (item.id ? item : { ...item, id }));

  const viewEntityDetails = (event, row) => {
    event.preventDefault();

    navigate(routeGenerator(row));
    updateKeys({ overlayHidden: true });
  };
</script>

{#if data && data.length}
  <div class="entity-wrapper">
    <h4>{title}</h4>
    <DataTable virtualize {headers} rows={dataWithId} size="compact">
      <span slot="cell" let:cell let:row>
        {#if cell.key === 'actions'}
          <Link href={routeGenerator(row)} on:click={(event) => viewEntityDetails(event, row)}>View details</Link>
        {:else if Array.isArray(cell.value)}
          {#if cell.value.length}
            <div class="tooltip-wrapper">
              <TooltipDefinition tooltipText={cell.value.join(', ')} portalTooltip>{cell.value.length}</TooltipDefinition>
            </div>
          {:else}
            &mdash;
          {/if}
        {:else if cell.display}
          {cell.display(cell.value, row)}
        {:else}
          {cell.value}
        {/if}
      </span>
    </DataTable>
  </div>
{/if}

<style>
  .entity-wrapper {
    padding-top: 2rem;
  }

  .entity-wrapper :global(tr td),
  .entity-wrapper :global(tr th) {
    white-space: nowrap;
  }

  .tooltip-wrapper :global(.bx--tooltip--definition),
  .tooltip-wrapper :global(.bx--tooltip__trigger) {
    position: static;
  }
</style>
